import { useEffect, useState } from 'react';

function usePreloader(img) {
    const [loading, setloading] = useState(false)
    useEffect(() => {
        const get = () => {
            setloading(true)
            const i = new Image();
            i.src = img
            i.addEventListener("load", () => setloading(false))
        }
        get()
        return () => get
    }, [img])
    return { loading }
}

export default usePreloader